const getTimezoneOffset = () => {
  const offset = ((new Date().getTimezoneOffset() / 60) * 100).toString();
  const sign = offset[0] === '+' ? '-' : '+';
  const offsetAbsoluteValue = offset[0] === '-' ? offset.substring(1) : offset;

  return `${sign}${offsetAbsoluteValue.padStart(4, '0')}`;
};

export function getDefaultQuietHourConfig() {
  const offset = getTimezoneOffset();
  return { quietHoursStart: `22:00:00.000${offset}`, quietHoursEnd: `07:30:00.000${offset}` };
}
